
import "jquery-sortable";

export module Sortable {

	export async function initAllAsync(container: JQuery): Promise<void> {

		var selector = ".sortable";
		var count = container.find(selector).length;

		return new Promise<void>((resolve, reject) => {

			if (count == 0) {
				resolve();
				return;
			}

			$.each(container.find(selector), async (i, e) => {
				var instance = new Sortable($(e));
				await instance.initAsync();
				count -= 1;
				if (count == 0)
					resolve();
			});

			//container.find(selector).each(async function () {
			//	var instance = new Sortable($(this));
			//	await instance.initAsync();
			//	count -= 1;
			//	if (count == 0)
			//		resolve();
			//});
		});

	}




	export class Sortable {

		private elemenet: JQuery;
		private groupKey: string = new Date().getTime().toString();

		constructor(element: JQuery) {
			this.elemenet = element;
			this.elemenet.attr("data-group-id", this.groupKey);
		}

		public initAsync(): Promise<void> {
			var adjustment;
			var handle: string | undefined = ".handle";
			if (this.elemenet.find(handle).length == 0)
				handle = undefined;

			var isTable = this.elemenet[0].tagName.toLowerCase() == "table";


			var options = <JQuerySortable.Options>{
				//group: "[data-group-id='" + this.groupKey + "']",
				pullPlaceholder: true,
                handle: handle,

                onDrag: ($item?: JQuery, position?: any, _super?: any, event?: any) => {
                    if ($item) {
                        $item.siblings(".placeholder").height($item.height());

                        if (event)
                            $item.css("top", event.clientY - this.elemenet.offset().top + "px");
                    }
                },

                onDrop: ($item, container, _super, event) => {
                        
					this.elemenet.trigger("drop", { item: $item, container: container, event: event });
					if (_super != null)
						_super($item, container);
				}
			};

			if (isTable) {

				var self = this;
				var thList = this.elemenet.find("tr th");

				options = {
					containerSelector: 'table',
					itemPath: '> tbody',
					itemSelector: 'tr',

					placeholder: '<tr class="placeholder"><td colspan="' + thList.length + '"></td></tr>',

					handle: handle,

					onDrag: ($item?: JQuery, position?: any, _super?: any, event?: any) => {

						if ($item ) {
							$item.siblings(".placeholder").height($item.height());

							if (event)
								$item.css("top", event.clientY - this.elemenet.offset().top + "px");

							var thList = self.elemenet.find("tr th");
							$item.find("td").each((i, e) => { $(e).width(thList.eq(i).width()); });

						}
					},

					onDrop: ($item?: JQuery, container?: any, _super?: any, event?: Event) => {
						//setTimeout(() => { self.elemenet.trigger("item-drop"); }, 1);
						if ($item)
							$item.removeClass("dragged");

						self.elemenet.trigger("item-drop"); 
					}
				};
			}

			return new Promise<void>((resolve, reject) => {
				this.elemenet.sortable(options);
				resolve();
			});
		}
	}
}

